export const RecentActivity = ({ recentActivity }) => (
  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
    {/* Recent Trips */}
    <div className="bg-white border border-stone-200 rounded-2xl p-6" data-testid="recent-trips-section">
      <h3 className="text-lg font-semibold text-stone-900 mb-4">Recent Trips</h3>
      <div className="space-y-3 max-h-[300px] overflow-y-auto">
        {recentActivity.recent_trips.map((trip, i) => (
          <div key={trip.id || i} className="flex items-center justify-between py-2 border-b border-stone-100 last:border-0">
            <div>
              <p className="text-sm font-medium text-stone-800">
                {trip.trip_input?.destination_city || 'Unknown'}, {trip.trip_input?.destination_country || ''}
              </p>
              <p className="text-xs text-stone-500">{trip.user_name || trip.user_email}</p>
            </div>
            <span className="text-xs text-stone-400">{trip.created_at?.slice(0, 10)}</span>
          </div>
        ))}
        {recentActivity.recent_trips.length === 0 && (
          <p className="text-sm text-stone-400 text-center py-6">No recent trips</p>
        )}
      </div>
    </div>

    {/* Recent Contacts */}
    <div className="bg-white border border-stone-200 rounded-2xl p-6" data-testid="recent-contacts-section">
      <h3 className="text-lg font-semibold text-stone-900 mb-4">Recent Contact Submissions</h3>
      <div className="space-y-3 max-h-[300px] overflow-y-auto">
        {recentActivity.recent_contacts.map((c) => (
          <div key={c.created_at || c.email} className="flex items-center justify-between py-2 border-b border-stone-100 last:border-0">
            <div>
              <p className="text-sm font-medium text-stone-800">{c.subject}</p>
              <p className="text-xs text-stone-500">{c.name} ({c.email})</p>
            </div>
            <span className="text-xs text-stone-400">{c.created_at?.slice(0, 10)}</span>
          </div>
        ))}
        {recentActivity.recent_contacts.length === 0 && (
          <p className="text-sm text-stone-400 text-center py-6">No contact submissions</p>
        )}
      </div>
    </div>
  </div>
);
